// 3rd party
import * as React from 'react';
import { MobXProviderContext } from 'mobx-react';

// Bernie
import { AnalyticsStore, ContextStore, ExperimentStore, PageStore, RouteStore } from 'bernie-core';

// Global Components
import { GlobalComponentsContextStore } from '@gc/global-controls-store';

// Stores
import {
  AccountDataStateStore,
  CaptchaStore,
  IndustryStore,
  LegalStore,
  LinkStore,
  ProductStore,
  ProgramStore,
  PzStore,
  PzCampaignStore,
  QuicklinkStore,
  UiStore,
  UserStore,
  UserAuthStore,
  PartnerPerfStore,
} from 'stores';

interface AffiliateHubStores {
  // Core
  analytics: AnalyticsStore;
  context: ContextStore;
  experiment: ExperimentStore;
  globalComponentsContext: GlobalComponentsContextStore;
  page: PageStore;
  routeStore: RouteStore;

  // App
  accountDataStateStore: AccountDataStateStore;
  captcha: CaptchaStore;
  industries: IndustryStore;
  legal: LegalStore;
  link: LinkStore;
  products: ProductStore;
  programs: ProgramStore;
  pzStore: PzStore;
  pzCampaignStore: PzCampaignStore;
  quicklinks: QuicklinkStore;
  uiStore: UiStore;
  user: UserStore;
  userAuth: UserAuthStore;
  partnerPerfStore: PartnerPerfStore;
}

function useStores() {
  return React.useContext(MobXProviderContext) as AffiliateHubStores;
}

export { useStores };
